module.exports = __webpack_public_path__ + "assets/img/text4.c99bbd8c.png";